module.exports = __webpack_public_path__ + "img/melvid-resumo1.1ab5c1ce.png";